// extracted by mini-css-extract-plugin
module.exports = {"giftItem":"styles_giftItem__3zI5q","giftsCard":"styles_giftsCard__2Cuhd"};